export const INSERT_TASK = "INSERT_TASK";
export const OPEN_TASK = "OPEN_TASK";
export const GET_TASKS_REQUEST = "GET_TASKS_REQUEST";
export const GET_TASKS_SUCCESS = "GET_TASKS_SUCCESS";
export const PUSH_NEW_TASKS = "PUSH_NEW_TASKS";
export const GET_USER_TASKS = "GET_USER_TASKS";
export const GET_ALL_USER_TASKS = "GET_ALL_USER_TASKS";
export const GET_TASKS_ARCHIVED_SUCCESS = "GET_TASKS_ARCHIVED_SUCCESS";
export const GET_TASKS_ARCHIVED_REQUEST = "GET_TASKS_ARCHIVED_REQUEST";
export const PUSH_ARCHIVED_TASKS = "PUSH_ARCHIVED_TASKS";
export const RESET_ARCHIVED_TASKS = "RESET_ARCHIVED_TASKS";
export const GET_TASKMAPS_REQUEST = "GET_TASKMAPS_REQUEST";
export const GET_TASKMAPS_SUCCESS = "GET_TASKMAPS_SUCCESS";
export const GET_TASKMAPMEMBER_REQUEST = "GET_TASKMAPMEMBER_REQUEST";
export const GET_TASKMAPMEMBER_SUCCESS = "GET_TASKMAPMEMBER_SUCCESS";
export const REMOVE_TASKMAP_MEMBER_SUCCESS = "REMOVE_TASKMAP_MEMBER_SUCCESS";
export const GET_TASK_MEMBER_SUCCESS = "GET_TASK_MEMBER_SUCCESS";
export const EDIT_TASK_CURRENT_DOING = "EDIT_TASK_CURRENT_DOING";
export const GET_TASK_CURRENT_DOING = "GET_TASK_CURRENT_DOING";
export const UPDATE_TASK_MAP_CURRENT_DOING = "UPDATE_TASK_MAP_CURRENT_DOING";
export const GET_TASK_MAP_CURRENT_DOING = "GET_TASK_MAP_CURRENT_DOING";
export const GET_BOARD_SUBTASKS_COUNT_REQUEST =
  "GET_BOARD_SUBTASKS_COUNT_REQUEST";
export const GET_BOARD_SUBTASKS_COUNT_SUCCESS =
  "GET_BOARD_SUBTASKS_COUNT_SUCCESS";
export const GET_SINGLE_TASK_SUCCESS = "GET_SINGLE_TASK_SUCCESS";
